import TrailersInfoDialog from './trailersInfoDialog';
export default TrailersInfoDialog;